var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebPrForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.78807 7.79473V7.79573H5.73495L9.77495 3.75162L9.78807 7.79473ZM13.2765 11.048V11.049C12.9408 11.048 12.6695 11.3203 12.6695 11.656C12.6695 11.9907 12.9408 12.263 13.2765 12.263H18.1837C18.5194 12.263 18.7918 11.9917 18.7918 11.656C18.7918 11.3203 18.5194 11.048 18.1837 11.048L13.2765 11.048ZM8.5871 15.4137C8.25144 15.4137 7.97909 15.686 7.97909 16.0207C7.97909 16.3564 8.25144 16.6287 8.5871 16.6287H18.1837C18.5194 16.6287 18.7918 16.3564 18.7918 16.0207C18.7918 15.686 18.5194 15.4137 18.1837 15.4137H8.5871ZM8.5871 19.7794C8.25144 19.7794 7.97909 20.0507 7.97909 20.3864C7.97909 20.7221 8.25144 20.9944 8.5871 20.9944H18.1837C18.5194 20.9944 18.7918 20.7221 18.7918 20.3864C18.7918 20.0507 18.5194 19.7794 18.1837 19.7794H8.5871ZM21.0369 3.7519V23.533L5.73495 23.5341V9.0111L10.395 9.0101C10.7306 9.0101 11.003 8.73875 11.003 8.40308V3.75308L21.0369 3.7519ZM9.53079 2.53687H9.52275C9.36698 2.53687 9.21322 2.59616 9.09462 2.71475L4.69778 7.11159C4.56713 7.24123 4.5209 7.4171 4.5209 7.58595L4.5199 24.1411C4.5199 24.3019 4.58321 24.4567 4.69778 24.5713C4.81134 24.6848 4.96612 24.7491 5.12692 24.7491L21.6438 24.7481C21.9794 24.7481 22.2508 24.4768 22.2508 24.1411V3.14512C22.2508 2.80945 21.9794 2.5381 21.6438 2.5381L9.53079 2.53687Z",
    fill: "url(#paint0_linear_169_4999)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0369 3.7519V23.533L5.73495 23.5341V9.0111L10.395 9.0101C10.7306 9.0101 11.003 8.73875 11.003 8.40308V3.75308L21.0369 3.7519ZM21.0369 3.7519L21.0367 3.75308M9.78807 7.79473V7.79573H5.73495L9.77495 3.75162L9.78807 7.79473ZM13.2765 11.048V11.049C12.9408 11.048 12.6695 11.3203 12.6695 11.656C12.6695 11.9907 12.9408 12.263 13.2765 12.263H18.1837C18.5194 12.263 18.7918 11.9917 18.7918 11.656C18.7918 11.3203 18.5194 11.048 18.1837 11.048L13.2765 11.048ZM8.58711 15.4137C8.25144 15.4137 7.97909 15.686 7.97909 16.0207C7.97909 16.3564 8.25144 16.6287 8.58711 16.6287H18.1837C18.5194 16.6287 18.7918 16.3564 18.7918 16.0207C18.7918 15.686 18.5194 15.4137 18.1837 15.4137H8.58711ZM8.58711 19.7794C8.25144 19.7794 7.97909 20.0507 7.97909 20.3864C7.97909 20.7221 8.25144 20.9944 8.58711 20.9944H18.1837C18.5194 20.9944 18.7918 20.7221 18.7918 20.3864C18.7918 20.0507 18.5194 19.7794 18.1837 19.7794H8.58711ZM9.53079 2.53687H9.52275C9.36698 2.53687 9.21322 2.59616 9.09462 2.71475L4.69778 7.11159C4.56713 7.24123 4.5209 7.4171 4.5209 7.58595L4.5199 24.1411C4.5199 24.3019 4.58321 24.4567 4.69778 24.5713C4.81134 24.6848 4.96612 24.7491 5.12692 24.7491L21.6438 24.7481C21.9794 24.7481 22.2508 24.4768 22.2508 24.1411V3.14512C22.2508 2.80945 21.9794 2.5381 21.6438 2.5381L9.53079 2.53687Z",
    stroke: "url(#paint1_linear_169_4999)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_169_4999",
    x1: -0.138555,
    y1: 135.926,
    x2: 71.8288,
    y2: 104.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_169_4999",
    x1: -0.138555,
    y1: 135.926,
    x2: 71.8288,
    y2: 104.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebPrForm);
export default __webpack_public_path__ + "static/media/web_PR_form.708b1b058c212cfe181ed201b35fa2c8.svg";
export { ForwardRef as ReactComponent };